import React from 'react';
import { Button } from './ui/Button';
import { Star } from 'lucide-react';
export function HeroSection() {
  return <section className="relative bg-[#FDF6E3] pt-8 pb-16 px-4 sm:px-6 lg:px-8 overflow-hidden min-h-screen flex flex-col items-center justify-center" data-id="element-81">
      <div className="max-w-6xl mx-auto text-center" data-id="element-82">
        {/* Badge */}
        <div className="inline-flex items-center gap-2 bg-[#1e3a5a] text-white px-6 py-2.5 rounded-full mb-8 shadow-lg" data-id="element-83">
          <Star className="w-5 h-5 text-[#d4a853] fill-[#d4a853]" data-id="element-84" />
          <span className="font-semibold text-sm sm:text-base tracking-wide" data-id="element-85">
            Sistema completo para docentes argentinos
          </span>
        </div>

        {/* Main Title */}
        <h1 className="text-4xl sm:text-5xl md:text-6xl lg:text-7xl font-black text-[#1e3a5a] tracking-tight mb-8 leading-none" data-id="element-86">
          POLÍTICA Y CIUDADANÍA 360
        </h1>

        {/* Product Mockup */}
        <div className="relative mx-auto max-w-4xl mb-10 cursor-pointer group" onClick={() => document.getElementById('comprar')?.scrollIntoView({
        behavior: 'smooth'
      })} data-id="element-87">
          <img src="https://cdn.magicpatterns.com/uploads/3MdZ6pAmuJnbfB4t6UavwB/MOCKUP_PRINCIPAL_POLITICA_Y_CIUDADANIA.png" alt="Política y Ciudadanía 360 - Pack completo para docentes" className="relative w-full object-contain transform transition duration-500 group-hover:scale-[1.02] drop-shadow-2xl" data-id="element-88" />
        </div>

        {/* Subtitle */}
        <h2 className="text-2xl sm:text-3xl md:text-4xl lg:text-5xl font-black text-[#1e3a5a] mb-4 leading-tight" data-id="element-89">
          <span className="italic" data-id="element-90">ORGANIZA TU AÑO DE</span>
          <br data-id="element-91" />
          <span className="text-[#2563eb] italic" data-id="element-92">
            POLÍTICA Y CIUDADANÍA SIN ESTRÉS
          </span>
        </h2>

        {/* Description */}
        <p className="text-lg sm:text-xl text-gray-600 mb-10 max-w-3xl mx-auto leading-relaxed" data-id="element-93">
          Sistema completo de proyectos, experiencias y evaluaciones listas para
          usar.
          <br className="hidden sm:block" data-id="element-94" />
          <strong className="text-[#1e3a5a]" data-id="element-95">
            Todo tu año de Política y Ciudadanía resuelto en un clic.
          </strong>
        </p>

        {/* CTA Button */}
        <Button className="text-xl px-10 py-5 w-full sm:w-auto shadow-xl" data-id="element-96">
          QUIERO ORGANIZAR MI AÑO AHORA
        </Button>
      </div>
    </section>;
}